import { ControlledCustomSelect } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';

import { useDictionaries } from 'entities/creditForm';

export const Education: FC<IFieldFactoryProps> = (props) => {
  const { educations } = useDictionaries(['educations']);
  const { type, ...other } = props;

  return (
    <ControlledCustomSelect
      {...other}
      name={type}
      options={educations}
      withCrossIcon={false}
    />
  );
};
